module.exports = __webpack_public_path__ + "img/IMG_4662.78fd7930.jpg";